<ng-container *ngIf="viewState === 'SIGN_IN'">
  <app-signin-form (redirectToAd)="redirectToAD($event)" (afterLoginState)="afterLoginState($event)"></app-signin-form>
</ng-container>

<ng-container *ngIf="viewState === 'MFA'">
  <app-multi-factor-authentication (MFAverified)="afterMfaVerified($event)" [MFAData]="MFAData" (LoginWithRecovery)="viewState = 'RECOVERY_PIN'"></app-multi-factor-authentication>
</ng-container>

<ng-container *ngIf="viewState === 'RECOVERY_PIN'">
  <app-recovery-pin [MFAData]="MFAData" (back)="viewState = 'MFA'" (recoveryCodeVerified)="afterMfaVerified($event)"></app-recovery-pin>
</ng-container>

<ng-container *ngIf="viewState === 'AD_REDIRECT'">
  <app-ad-redirection></app-ad-redirection>
</ng-container>

<ng-container *ngIf="false">
  <app-link-expired></app-link-expired>
</ng-container>

<!-- <lib-otp-input (onInputChange)="RecoveryCode =$event"  [config]="{length:6,allowNumbersOnly:true}" ></lib-otp-input> -->
<!-- <lib-recovery-pin (onInputChange)="RecoveryCode =$event"  [config]="{length:3,allowNumbersOnly:true}" ></lib-recovery-pin> -->
